import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import { addMovieBack,handleMovieDetails, handleMoreMovies } from '../actions'

export default class MovieCard extends Component {
    render() {
        const { data } =this.props;
        const detailsHandle = ()=>{
            const {dispatch} =this.props;
            dispatch(addMovieBack(data.backdrop_path));
            if(data.title){
                dispatch(handleMovieDetails(data.title));
            }else{
                dispatch(handleMovieDetails(data.name));
            }
            
            dispatch(handleMoreMovies(data.original_language,data.genre_ids[0]));
            window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
         }
        return (
            <Link style={{textDecoration:'none'}} to="/movie-details">
            <div onClick={detailsHandle} className="movie-card" style={{backgroundImage:`url('https://image.tmdb.org/t/p/original/${data.backdrop_path}')`}}>
              <p className="movie-card-title">{data.title}{!data.title&&data.name}</p>

            </div>
            </Link>
        )
    }
}
